/**
 * Ensure some object is a coerced to a string
 **/
module.exports = function makeString(object) {
  if (object == null) return '';
  return '' + object;
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/helper/makeString.js
// module id = 409
// module chunks = 0